<template>

  <!-- Partition notice modal template -->
  <b-modal ref="view-modal" hide-footer @hide="hideModal">
    <div class="d-block text-center">
      <h4 qid="update-tp-title">
        {{ $t('system.different_client_title') }}
      </h4>
    </div>

    <div class="mt-5 text-center">
      <h6>
        {{ $t('system.different_client_description') }}
      </h6>
    </div>

    <br>

    <div class="text-right">
      <b-button class="mt-3"
                variant="secondary"
                @click="hideModal"
                qid="create-p-cancel-button"
      >
        {{ $t('systems.create.cancel') }}
      </b-button>
      <router-link
          v-if="(item.client && !item.active_client) || (item.client && item.active_client)"
          class="mt-3 ml-3 btn btn-success"
          :to="{ name: state, params: { slug: item.slug, client: item.client}}"
      >
        {{ $t('system.continue') }}
      </router-link>
      <router-link
          v-if="item.active_client && !item.client"
          class="mt-3 ml-3 btn btn-success"
          :to="{ name: state, params: { slug: item.slug, client: item.active_client.slug }}"
      >
        {{ $t('system.continue') }}
      </router-link>
    </div>

    <br>

  </b-modal>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue'

  export default {
    name: 'ShowMoreModal',
    data: function() {
      return {
        error: '',
        showInput: false,
        loadingItems: false,
      }
    },
    props: {
      item: {
        type: Object
      },
      state: {
        type: String
      },
      show: {
        type: Boolean
      },
    },
    components: {
      Avatar
    },
    computed: {
      getClient() {
        return this.$store.state.client
      }
    },
    watch: {
      // Watch when prop changes
      show: function (value) {
        if (value) {
          this.showModal()
        }
      }
    },
    methods: {
      showModal() {
        let self = this
        this.$refs['view-modal'].show()
      },
      hideModal() {
        this.error = ''
        this.$emit('closeViewModal');
        this.$refs['view-modal'].hide()
      }
    },
    created () {

    }
  }
</script>
